























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { Order } from '@/models/index'

@Component({
  name: 'OrdersTable',
  components: {
    Pagination,
    FiltersDrawer: () => import('../components/FiltersDrawer.vue'),
    GiftCardSelect: () => import('@/components/GiftCardSelect/index.vue'),
    CardDistributionTooltip: () => import('@/components/CardDistributionTooltip/index.vue')
  }
})
export default class extends Vue {
  @Prop({ required: true }) private giftCards!: any[]
  @Prop({ required: true }) private giftCardsLoading!: boolean
  @Prop({ required: true }) private buyers!: any[]
  @Prop({ required: true }) private buyersLoading!: boolean
  @Prop({ required: true }) private wholesalers!: any[]
  @Prop({ required: true }) private wholesalersLoading!: boolean

  private tableOrderKey = 0
  private listOrder: Order[] = []
  private totalOrder = 0
  private loadingOrder = true
  private listQuery = {
    page: 1,
    limit: 20,
    number: undefined,
    status: undefined,
    giftCardId: '',
    buyerId: '',
    wholesalerId: '',
    paymentStatus: undefined,
    deliveryStatus: undefined,
    dateRange: null
  }

  private transferOrderDrawerVisible = false
  private transferOrderSelected: Order | null = null

  private paymentStatusOptions = [
    {
      value: 'unpaid',
      label: 'Non payée'
    },
    {
      value: 'paid',
      label: 'Payée'
    },
    {
      value: 'late',
      label: 'En retard'
    }
  ]

  private deliveryStatusOptions = [
    {
      value: 'undelivered',
      label: 'Non livrée'
    },
    {
      value: 'in_delivery',
      label: 'En livraison'
    },
    {
      value: 'delivered',
      label: 'Livrée'
    }
  ]

  created() {
    this.getListOrder()
  }

  private async deliverAll() {
    return await Order.deliverAll()
  }

  private async getListOrder() {
    this.loadingOrder = true
    const createdAtGte = this.listQuery.dateRange ? this.$moment(String(this.listQuery.dateRange![0])).startOf('day').format('YYYY-MM-DD HH:mm:ss') : ''
    const createdAtLte = this.listQuery.dateRange ? this.$moment(String(this.listQuery.dateRange![1])).endOf('day').format('YYYY-MM-DD HH:mm:ss') : ''

    const { data, meta } =
        await Order
          .where({
            number: { prefix: this.listQuery.number },
            status: this.listQuery.status,
            giftCardId: this.listQuery.giftCardId,
            buyerId: this.listQuery.buyerId,
            wholesalerId: this.listQuery.wholesalerId,
            paymentStatus: this.listQuery.paymentStatus,
            deliveryStatus: this.listQuery.deliveryStatus,
            createdAt: { gte: createdAtGte, lte: createdAtLte },
            bulk: false
          })
          .includes(['buyer', 'giftCard', 'seller', 'wholesaler', 'invoices', 'cardDistributions'])
          .order({ createdAt: 'desc' })
          .page(this.listQuery.page)
          .per(this.listQuery.limit)
          .stats({ total: 'count' })
          .all()

    this.listOrder = data
    this.totalOrder = meta.stats.total.count
    this.loadingOrder = false
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.getListOrder()
  }

  private handleGiftCardSelect(giftCardId: string) {
    this.listQuery.page = 1
    this.listQuery.giftCardId = giftCardId
    this.getListOrder()
  }

  private handleBuyerSelect(buyerId: string) {
    this.listQuery.page = 1
    this.listQuery.buyerId = buyerId
    this.getListOrder()
  }

  private async handleDelete(data: Order, index: number) {
    await data.destroy()

    this.$notify({
      title: 'Success',
      message: 'Delete Successfully',
      type: 'success',
      duration: 2000
    })
    this.listOrder.splice(index, 1)
    this.totalOrder -= 1
  }

  private handleAction(command: any, order: Order) {
    if (command === 'edit') this.$router.push({name: 'OrderEdit', params: {id: order.id}})
  }

  private handleWholesalerSelect(wholesalerId: string) {
    this.listQuery.page = 1
    this.listQuery.wholesalerId = wholesalerId
    this.getListOrder()
  }

  private applyFilters(filters: any) {
    this.listQuery.status = filters.status
    this.listQuery.dateRange = filters.dateRange
    this.listQuery.paymentStatus = filters.paymentStatus
    this.listQuery.deliveryStatus = filters.deliveryStatus
    this.listQuery.page = 1
    this.getListOrder()
  }
}
